import { Link } from 'react-router-dom'
import { Tags, Sparkles, FileText, BarChart3, Search } from 'lucide-react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'

/**
 * Quick action item configuration
 */
const quickActions = [
  {
    title: 'Create New Attribute',
    description: 'Define a new attribute schema',
    href: '/pac/attributes/create',
    icon: Tags,
  },
  {
    title: 'Start with poli-x AI',
    description: 'Use AI to help create policies',
    href: '/polix-ai',
    icon: Sparkles,
  },
  {
    title: 'Create Policy',
    description: 'Manually create a new policy',
    href: '/pac/policies/create',
    icon: FileText,
  },
  {
    title: 'View Reports',
    description: 'Analytics and activity reports',
    href: '/pac/reports',
    icon: BarChart3,
  },
  {
    title: 'Scan Connections',
    description: 'Discover sensitive data in databases',
    href: '/discovery/connections',
    icon: Search,
  },
]

/**
 * Quick Actions card for dashboard
 * Provides shortcuts to common tasks
 */
export function QuickActions() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common tasks to get you started</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3">
        {quickActions.map((action) => (
          <Button
            key={action.href}
            variant="outline"
            className="justify-start h-auto py-3 hover:bg-primary/5 hover:border-primary/20 transition-[background-color,border-color] duration-200"
            asChild
          >
            <Link to={action.href}>
              <action.icon className="mr-3 h-5 w-5 text-muted-foreground" />
              <div className="text-left">
                <div className="font-medium">{action.title}</div>
                <div className="text-xs text-muted-foreground">
                  {action.description}
                </div>
              </div>
            </Link>
          </Button>
        ))}
      </CardContent>
    </Card>
  )
}
